export default "https://cdn-static.gokick.com/assets/bc95401d28f090206b11ed03f14553a528aaf8ef/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";